<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-after: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Under a Blue Moon</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Bru Baker</p>
<p class="P_Norm-NoIndent">A Camp H.O.W.L. Novel</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Once in a blue moon, opposites find they’re a perfect match.</p>
<p class="P_Normal">Nick Perry is tired of helping people with their marriages, so when a spot opens up to work with teens at Camp H.O.W.L., he jumps at it. He doesn’t expect to fall in lust with the dreamy new camp doctor, Drew Welch. But Drew is human, and Nick has seen secrets ruin too many relationships to think that a human/werewolf romance can go anywhere.</p>
<p class="P_Normal">Happy-go-lucky Drew may not sprout claws, but he’s been part of the Were community all his life. He has no trouble fitting in at the camp—except for Nick’s stubborn refusal to acknowledge the growing attraction between them and his ridiculous stance on dating humans. Fate intervenes when the abusive boyfriend of one of his private-practice patients threatens Drew’s life. Will the close call help Nick to see a connection like theirs isn’t something to let go of?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?68cd390e